import React, { useEffect, useRef, useState } from 'react'
import {
  AddNewRowWrapperBtn,
  AddRowBoxWrapper,
  AdvacneReplyBox,
  AdvanceButtonsWrapper,
  AdvanceFilterWrapper,
  AdvanceSearchWrapper,
  AdvSearchCheckbox,
  AdvSearchInput,
  AdvSearchInputWrapper,
  BottomInput,
  CenterAddRowWrapper,
  ChipsItem,
  DisplayChipsWrapper,
  EmptyRowText,
  FiltersBox,
  FormWrapper,
  Highlight,
  LabelNames,
  LeftRadio,
  RadioWrapper,
  RightCheckBox,
  TextIconWrapper,
  TextWrapper,
  TopContent,
  TrashButton,
} from './style'
import {
  Modal,
  MuiButton,
  MuiCheckbox,
  MuiRadio,
  MuiRadioButton,
  MuiTextField,
} from '../../../../../components'
import {
  IconAddRow,
  IconAdvanceSearchBar,
  IconCross,
  IconFilterChips,
  IconReply,
  IconTrashAdvSearch,
} from '../../../../../assets/images/icons'
import { Box, Checkbox, colors, Radio } from '@mui/material'
import Filters from '../filters'
import { useLocation } from 'react-router-dom'
const AdvanceSearch = ({
  filterData,
  resetApiCall,
  onApplyFilters,
  setFilterData,
  insightsElementId,
  updateQuery,
  updateChips,
  rows,
  setRows,
  parsedRows,
}) => {
  const [open, setOpen] = useState(false)
  // const [filterData, setFilterData] = useState({
  //     searchText: filterData.searchText,
  //     entityName: filterData.entityName,
  //     driverName: filterData.driverName,
  //     attributeName: filterData.attributeName,
  //     rows: [],
  //     verbatim: true,
  //     metadata: true, })
  // const [appliedFilters, setAppliedFilters] = useState(null);
  // const [isDeleteTriggered, setIsDeleteTriggered] = useState(false);
  const uid = useRef(2)
  const location = useLocation()
  const queryString = location.search
  const params = new URLSearchParams(queryString)

  const handleOpen = () => {
    setOpen(true)
    const newRow = {
      id: uid.current++,
      text: '',
      matchType: '',
      verbatim: true,
      metadata: true,
      showError: false,
      matchTypeSelected: false,
    }
    console.log(newRow, 'newRow')

    if (rows.length === 0) {
      setRows([newRow])
      setFilterData({ ...filterData, rows: parsedRows() || newRow })
    }

    const verbatimParam = params.get('verbatim')
    const metadataParam = params.get('metadata')

    const isVerbatim =
      verbatimParam === null && metadataParam === null ? true : verbatimParam === 'true'

    const isMetadata =
      verbatimParam === null && metadataParam === null ? true : metadataParam === 'true'

    updateQuery({
      ...filterData,
      rows: parsedRows() || rows,
      verbatim: isVerbatim,
      metadata: isMetadata,
    })
  }

  const handleClose = () => {
    setOpen(false)

    // setFilterData({
    //   ...filterData,
    //   entityName: params.get('entityName') || filterData.entityName,
    //   driverName: params.get('driverName') || filterData.driverName,
    //   attributeName: params.get('attributeName') || filterData.attributeName,
    //   searchText: params.get('searchText') || filterData.searchText,
    //   verbatim: params.get('verbatim') === 'true' && filterData.verbatim,
    //   metadata: params.get('metadata') === 'true' && filterData.metadata,
    //   // rows: parsedRows() || []
    // });
    setFilterData(filterData)
    updateQuery(filterData)
  }

  const handleTopCheckboxChange = (e) => {
    console.log('Clicked Checkbox:', e.id, e.checked)
    const updatedData = { ...filterData, [e.id]: e.checked }

    if (!updatedData.verbatim && !updatedData.metadata) {
      return
    }

    setFilterData({ ...filterData, [e.id]: e.checked })
  }

  const handleInputChange = (id, value) => {
    setRows(
      rows.map((row) =>
        row.id === id ? { ...row, text: value, showError: value.trim() === '' } : row
      )
    )
  }
  const handleMatchTypeChange = (id, value) => {
    setRows(
      rows.map((row) =>
        row.id === id ? { ...row, matchType: value, matchTypeSelected: true } : row
      )
    )
  }

  const handleRowCheckboxChange = (id, name, value) => {
    setRows((prevRows) => {
      return prevRows.map((row) => {
        if (row.id !== id) return row

        const newRow = { ...row, [name]: value }

        if (!newRow.verbatim && !newRow.metadata) {
          return row
        }

        return {
          ...newRow,
        }
      })
    })
  }

  const handleAddRow = () => {
    const newRow = {
      id: uid.current++,
      text: '',
      matchType: '',
      verbatim: true,
      metadata: true,
      showError: false,
      matchTypeSelected: false,
    }
    console.log(newRow, 'newRow')

    setRows([...rows, newRow])
  }
  const handleDeleteRow = (id) => {
    setRows(rows.filter((row) => row.id !== id))
  }

  const isApplyDisabled = () => {
    const hasMainSearch = filterData.searchText?.trim()
    const hasTopCheckbox = filterData.verbatim || filterData.metadata
    // const hasAnyRowFilled = rows.every(row => row.text.trim());
    // const hasRowCheckbox = rows.some(row => row.verbatim || row.metadata);
    const validRows = rows.every((row) => {
      if (row.matchType) {
        return row.text.trim() && (row.verbatim || row.metadata)
      }
      return true
    })

    return !(hasMainSearch && hasTopCheckbox && validRows)
  }

  const areAllRowsValid = rows.every(
    (row) => row.text.trim() && row.matchType && (row.verbatim || row.metadata)
  )

  const handleApply = () => {
    const payload = {
      ...filterData,
      rows,
    }

    if (areAllRowsValid) {
      // setAppliedFilters(payload);
      setRows(rows)
      setFilterData(payload)
      onApplyFilters(payload)
      updateChips(payload)
      updateQuery(payload)
      handleClose()
    } else if (rows.length === 1 && rows[0]?.matchTypeSelected === false && rows[0]?.text === '') {
      setRows(rows)
      setFilterData(payload)
      onApplyFilters({ ...payload, rows: [] })
      updateChips({ ...payload, rows: [] })
      updateQuery({ ...payload, rows: [] })
      handleClose()
    } else {
      console.log('error')
    }
  }

  const handleReset = () => {
    setRows([
      {
        id: 1,
        text: '',
        matchType: '',
        verbatim: true,
        metadata: true,
        showError: false,
        matchTypeSelected: false,
      },
    ])
    // setAppliedFilters(null);

    const resetData = {
      verbatim: true,
      metadata: true,
      searchText: '',
      entityName: '',
      driverName: '',
      attributeName: '',
      rows: [],
    }
    setFilterData(resetData)
    updateQuery(resetData)
    // onApplyFilters(resetData);
  }

  // For generate the message --------------------------------------------------
  const generateSearchMessage = () => {
    if (!filterData?.searchText?.trim() && filterData.rows.every((row) => !row.text.trim())) {
      return (
        <span style={{ color: 'black' }}>
          Enter keywords and filters above to see verbatim insights based on your selection.
        </span>
      )
    }

    const messageParts = []

    // Top-level searchText
    if (filterData?.searchText?.trim()) {
      const label = <Highlight>"{filterData.searchText.trim()}"</Highlight>
      let searchIn = []

      if (filterData.verbatim) searchIn.push('Verbatim')
      if (filterData.metadata) searchIn.push('Metadata')

      let context = ''
      if (searchIn.length === 1) {
        context = ` (in ${searchIn[0]})`
      }
      // else if (searchIn.length > 1) {
      //   context = ` (in ${searchIn.join(' and ')})`;
      // }

      messageParts.push(
        <span key='main-search'>
          {label}
          {context}
        </span>
      )
    }

    // Row-level searches
    filterData.rows.forEach((row, index) => {
      if (!row.text?.trim()) return

      const label = <Highlight>"{row.text.trim()}"</Highlight>
      let searchIn = []

      if (row.verbatim) searchIn.push('Verbatim')
      if (row.metadata) searchIn.push('Metadata')

      let context = ''
      if (searchIn.length === 1) {
        context = ` (in ${searchIn[0]})`
      }
      // else if (searchIn.length > 1) {
      //   context = ` (in ${searchIn.join(' and ')})`;
      // }

      let prefix = ''
      if (row.matchType === 'and') {
        prefix = 'and'
      } else if (row.matchType === 'not') {
        prefix = 'and without'
      }

      messageParts.push(
        <span key={`row-${index}`}>
          {' '}
          {prefix} {label}
          {context}
        </span>
      )
    })

    const pathParts = [
      filterData.entityName,
      filterData.driverName,
      filterData.attributeName,
    ].filter(Boolean)

    const pathTrail = pathParts.length ? <>, in {pathParts.join(' › ')}</> : null

    return (
      <>
        <span style={{ color: '#D47501' }}>Show verbatim insights mentioning</span> {messageParts}
        {pathTrail}.
      </>
    )
  }

  // useEffect(() => {
  //   if (isDeleteTriggered) {
  //     handleApply();
  //     setIsDeleteTriggered(false);
  //   }
  // }, [appliedFilters]);

  useEffect(() => {
    setFilterData({
      ...filterData,
      rows,
    })
  }, [rows])

  // Loose Enter key event handler
  useEffect(() => {
    if (!open) return
    const handleEnter = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        if (filterData.searchText && filterData.searchText.trim()) {
          e.preventDefault()
          handleApply()
        }
      }
    }
    window.addEventListener('keydown', handleEnter)
    return () => {
      window.removeEventListener('keydown', handleEnter)
    }
  }, [open, rows, filterData])

  return (
    <AdvanceSearchWrapper>
      <MuiButton
        className='advance-search-btn'
        variant='text'
        color='primary'
        startIcon={<IconAdvanceSearchBar />}
        size='small'
        label='Advance Search'
        onClick={handleOpen}
      />

      {open && (
        <Modal title='Advanced Search' showClose={true} onClose={handleClose} styleType='themeV2'>
          <FormWrapper>
            <form style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <AdvSearchInputWrapper>
                <AdvSearchInput>
                  <Filters
                    type='searchOnly'
                    parsedRows={parsedRows}
                    // setFilteredData={setFilterData}
                    // filteredData={filterData}
                    // insightsElementId={props.InsightsElementId}
                    // onFilterChange={handleSubmit}
                    // updateChips={setChipData}
                    // filterDataInput={filterData}
                    setFilteredData={(d) => setFilterData({ ...filterData, ...d })}
                    filteredData={filterData}
                    insightsElementId={insightsElementId}
                  />
                </AdvSearchInput>

                <AdvSearchCheckbox className='adv-search-r'>
                  <LabelNames>Search In{'\u00A0'}</LabelNames>
                  {/* <label><Checkbox 
                            id='verbatim'
                            checked={filterData.verbatim}
                            onChange={handleTopCheckboxChange}
                     />Verbatim</label>

                    <label><Checkbox 
                            id='metadata'
                            checked={filterData.metadata}
                            onChange={handleTopCheckboxChange}
                     /> Metadata</label> */}

                  <MuiCheckbox
                    id='verbatim'
                    styling='themeV2'
                    label='Verbatim'
                    checked={filterData.verbatim}
                    onChange={handleTopCheckboxChange}
                  />
                  <MuiCheckbox
                    id='metadata'
                    styling='themeV2'
                    label='Metadata'
                    checked={filterData.metadata}
                    onChange={handleTopCheckboxChange}
                  />
                </AdvSearchCheckbox>
              </AdvSearchInputWrapper>

              <CenterAddRowWrapper>
                <AddRowBoxWrapper>
                  {rows.length === 0 && (
                    <RadioWrapper>
                      <EmptyRowText>
                        You've removed all conditions. Add a new rule to start building your
                        advanced search.
                      </EmptyRowText>
                    </RadioWrapper>
                  )}

                  {rows.map((row, index) => {
                    console.log(row, 'i')

                    return (
                      <RadioWrapper key={row.id}>
                        <TopContent>
                          <LeftRadio>
                            <LabelNames>Match{'\u00A0\u00A0\u00A0'}</LabelNames>

                            <label>
                              <MuiRadioButton
                                name={`matchType-${row.id}`}
                                value='and'
                                styling='themeV2'
                                checked={row.matchType === 'and'}
                                onChange={(e) => handleMatchTypeChange(row.id, e.target.value)}
                                title='And'
                                styletype='themeV2'
                              />
                            </label>

                            <label>
                              <MuiRadioButton
                                name={`matchType-${row.id}`}
                                value='not'
                                styling='themeV2'
                                checked={row.matchType === 'not'}
                                onChange={(e) => handleMatchTypeChange(row.id, e.target.value)}
                                title='Not'
                                styletype='themeV2'
                              />
                            </label>
                          </LeftRadio>

                          <TrashButton onClick={() => handleDeleteRow(row.id)}>
                            <IconTrashAdvSearch />
                          </TrashButton>
                        </TopContent>

                        <BottomInput>
                          <MuiTextField
                            name={`searchText-${row.id}`}
                            placeholder='Enter Keywords...'
                            compact
                            className={`searchBox ${row.showError ? 'with-error' : ''}`}
                            error={row.showError}
                            helperText={row.showError ? 'Match case keywords required.' : ''}
                            onChange={(e) => handleInputChange(row.id, e.target.value)}
                            value={row.text}
                            styletype='themeV2'
                            disabled={!row.matchTypeSelected}
                          />
                          <RightCheckBox>
                            <LabelNames>Search In {'\u00A0'}</LabelNames>

                            <MuiCheckbox
                              // id={'verbatim'+index}
                              styling='themeV2'
                              label='Verbatim'
                              checked={row.verbatim}
                              onChange={(e) =>
                                handleRowCheckboxChange(row.id, 'verbatim', e.checked)
                              }
                              disabled={!row.matchTypeSelected}
                            />
                            <MuiCheckbox
                              // id={'metadata'+index}
                              styling='themeV2'
                              label='Metadata'
                              checked={row.metadata}
                              onChange={(e) =>
                                handleRowCheckboxChange(row.id, 'metadata', e.checked)
                              }
                              disabled={!row.matchTypeSelected}
                            />
                          </RightCheckBox>
                        </BottomInput>
                      </RadioWrapper>
                    )
                  })}
                </AddRowBoxWrapper>

                <AddNewRowWrapperBtn>
                  <MuiButton
                    color='light'
                    variant='contained'
                    startIcon={<IconAddRow />}
                    label='Add New Rule'
                    onClick={handleAddRow}
                    disabled={!areAllRowsValid}
                  />
                </AddNewRowWrapperBtn>
              </CenterAddRowWrapper>

              <AdvanceFilterWrapper>
                <LabelNames>Filters</LabelNames>
                <FiltersBox>
                  <Filters
                    type='showDropdown'
                    filterDataInput={filterData}
                    setFilteredData={(d) => setFilterData({ ...filterData, ...d })}
                    filteredData={filterData}
                    insightsElementId={insightsElementId}
                    parsedRows={parsedRows}
                  />
                </FiltersBox>
              </AdvanceFilterWrapper>

              <AdvacneReplyBox>
                <TextIconWrapper>
                  <IconReply />
                </TextIconWrapper>
                <TextWrapper>
                  {generateSearchMessage() ||
                    'Enter keywords and filters above to see verbatim insights based on your selection.'}
                </TextWrapper>
              </AdvacneReplyBox>

              <AdvanceButtonsWrapper>
                <MuiButton onClick={handleReset} variant='contained' color='gray' label='Reset' />

                <MuiButton
                  onClick={handleApply}
                  disabled={isApplyDisabled()}
                  variant='contained'
                  color='primary'
                  label='Apply Filters'
                />
              </AdvanceButtonsWrapper>
            </form>
          </FormWrapper>
        </Modal>
      )}
    </AdvanceSearchWrapper>
  )
}

export default AdvanceSearch
